export const BASE_URL = "https://redlabs.org.in/red_backend/api";
export const IMG_URL = "https://redlabs.org.in/red_backend/uploads";
export const CDN_URL = "https://cdn.acsdev.in/r-ed"